// event size + 4px of gap
export const GRID_COLUMN_MIN_WIDTH_DAY = '124px';
export const GRID_COLUMN_MIN_WIDTH_MONTH = '36px';
export const GRID_LABEL_COLUMN_WIDTH = '14rem';
export const GRID_GAP_SIZE = 2;
export const GRID_LABEL_COLUMN_SMALL_WIDTH = '3rem';
export const GRID_SUMMARY_COLUMN_WIDTH = '5rem';
